import styled from 'styled-components'

import { zIndexRegistry } from '@/constants/zIndexRegistry'
import { Button } from '@/ui/atoms/button'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const GLOBAL_HEADER_MAX_WIDTH = '128rem'

type ContainerProps = {
  hasChildren?: boolean
  isPSABannerVisible?: boolean
}
export const Container = styled.header<ContainerProps>(
  ({ theme, hasChildren, isPSABannerVisible }) => `
	background-color: ${theme.colors.white};
	${!isPSABannerVisible ? `border-top: solid 0.5rem ${theme.colors.purple.primary};` : ''}
	box-shadow: 0 0.2rem 0.5rem rgb(0 0 0 / 5%);
	display: flex;
	justify-content: center;
	width: 100%;
  padding: ${
    hasChildren ? `${theme.spacing.default} ${theme.spacing.default} 0` : `${theme.spacing.default}`
  };
  z-index: ${zIndexRegistry.MAIN_MENU};
`
)

export const GlobalHeaderContainer = styled.div`
  display: flex;
  max-width: ${GLOBAL_HEADER_MAX_WIDTH};
  width: 100%;
  flex-direction: column;
`

export const Wrapper = styled.div(
  ({ theme }) => `
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: ${GLOBAL_HEADER_MAX_WIDTH};
  overflow: visible;
  width: 100%;

  ${MEDIA_QUERIES(theme).xLarge} {
    flex-wrap: nowrap;
  }
`
)

/** LOGO */

export const LogoWrapper = styled.div(
  ({ theme }) => `
  order: 1;
  min-height: 3.3rem;
  min-width: 2.2rem;

  ${MEDIA_QUERIES(theme).medium} {
    margin-right: ${theme.spacing.large};
    min-width: 6.3rem; 
  }
`
)

// eslint-disable-next-line @kijiji/prefer-link-custom
export const KijijiLogoLink = styled.a`
  display: block;

  svg {
    height: 3.3rem;
    width: auto;
  }
`

/** POST AD CTA */

//Modifications have been made to ensure that the NWA and legacy post ad buttons match
export const PostAdButton = styled(Button)(
  ({ theme }) => `
  margin-left: ${theme.spacing.defaultSmall};
  text-decoration: none;
  font-size: ${theme.spacing.default};

  ${MEDIA_QUERIES(theme).medium} {
    margin-left: 1.8rem;
  }
`
)

/** In order to match legacy code, a specific media query breakpoint is used below which isn't present in theme constants. */
/** if in future we want to bring it up to standard, we would need to upgrade both legacy and NWA with theme constants- either small or mediumSmall */
export const DesktopLogoContainer = styled.div`
  display: none;

  & svg {
    height: 3.3rem;
    width: 6.3rem;
  }

  @media (min-width: 375px) {
    display: block;
  }
`

export const MobileLogoContainer = styled.div`
  display: block;

  & svg {
    height: 3.3rem;
    width: 2.2rem;
  }

  @media (min-width: 375px) {
    display: none;
  }
`
